import { Component, Input } from '@angular/core';
import { Block } from '@core/models/block/block.model';
import { BlockAction } from '@core/models';
import { BlockActionType } from '@core/enums';
import { BuyLoaderService } from '@core/services/common/buy-loader.service';

@Component({
    selector: '[app-special-block-container]',
    templateUrl: './special-block-container.component.html',
    styles: [`
    :host {
      position: relative;
      width: 100%;
    }

    .loader {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      background: #000;
    }
  `],
    standalone: false
})
export class SpecialBlockContainerComponent {
  @Input() item: Block;
  @Input() action: BlockAction;

  constructor(private buyLoaderService: BuyLoaderService) {
  }

  get showLoader() {
    return this.buyLoaderService.showLoader;
  }

  get isButtonWithLoader() {
    return this.action.actionType === BlockActionType.BUY_NOW;
  }
}
